<template>
  <div class="action-btn-wrapper">
    <b-button-group>
      <b-button
        class="acceptBtn"
        pill
        :variant="actionVariant"
        @click="$emit('pend-report')"
        :disabled="isControlTypeSelected"
      >
        {{ contentString.pending[loginCountry] }}
      </b-button>
      <b-button
        class="acceptBtn"
        pill
        :variant="actionVariant"
        @click="$emit('apply-direct-control')"
      >
        {{ contentString.pass[loginCountry] }}
      </b-button>
      <b-button
        class="acceptBtn"
        pill
        :variant="actionVariant"
        @click="$emit('apply-to-cleanliness-lab')"
        :disabled="isControlTypeSelected"
      >
        {{ confirmLabel }}
      </b-button>
      <b-button
        class="acceptBtn"
        pill
        :variant="actionVariant"
        @click="$emit('reject-report')"
        :disabled="isControlTypeSelected"
      >
        {{ contentString.notApplyScore[loginCountry] }}
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  props: {
    contentString: Object,
    loginCountry: String,
    isControlTypeSelected: {
      type: Boolean,
      default: false,
    },
    confirmLabel: {
      type: String,
      required: true,
    },
    actionVariant: {
      type: String,
      default: "success",
    },
  },
};
</script>

<style scoped>
.acceptBtn {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
  width: 160px;
  font-size: small;
}
</style>
